import { createReducer, on } from "@ngrx/store";
import { DocViewerState } from "@store/doc-viewer/doc-viewer.state";
import { documentViewActions } from "@store/doc-viewer/document-view/document-view.actions";

export const documentViewReducers = createReducer<DocViewerState['currentDocumentView']>(
	'pdf',
	on(documentViewActions.viewUpdated, (_state, {selectedView}) => {
		return selectedView;
	}),
	on(documentViewActions.viewInitialized, (_state, {selectedView}) => {
		return selectedView;
	}),
);